var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center py-6",class:{
    'flex-column': _vm.$vuetify.breakpoint.mdAndDown,
    'flex-row': _vm.$vuetify.breakpoint.mdAndDown,
    'white--text': _vm.light,
  }},[_c(_vm.light ? 'homify-icon-light' : 'homify-icon-dark',{tag:"component"}),(_vm.$vuetify.breakpoint.mdAndUp && _vm.showNav)?_c('div',{staticClass:"d-flex ml-4 flex-row",class:{
      'flex-column': _vm.$vuetify.breakpoint.mdAndDown,
      'nav-border--left__dark': !_vm.light,
      'nav-border--left': _vm.light,
    }},_vm._l((_vm.navItems),function(navItem,idx){return _c('div',{key:idx,staticClass:"px-5 font-weight-light text-h6"},[_vm._v(" "+_vm._s(navItem.name)+" ")])}),0):_vm._e(),(_vm.showAuth)?_c('div',{staticClass:"ml-auto"},[_c('hm-button',{staticClass:"mr-3",attrs:{"text-color":"secondary--text","color":"transparent"}},[_vm._v("Login")]),_c('hm-button',[_vm._v("Sign Up")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }